<template>
  <div id="modal-file-select">
    <transition
      name="modal"
      appear
    >
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container-outer">
            <ButtonClose
              class="modal-default-button"
              @click="$emit('close')"
            />
            <div class="modal-container mx-3 py-4">
              <div class="modal-contents">
                <div
                  class="row my-2 p-3 file-select"
                  :class="{ dragging: drag }"
                  @dragover.prevent="drag = true"
                  @dragleave.prevent="drag = false"
                  @drop.prevent="readfile"
                >
                  <div class="file-select-inner">
                    <p v-text="$t('labels.fileDragAndDropOrFileSelect')"></p>
                    <div class="button-file-select">
                      <button
                        type="button"
                        class="btn btn-black btn-sm px-4 py-1"
                        color="table-row-upload"
                        style="color: black; border: solid 1px #b3b3b3;"
                        @click="onClickFileSelect"
                      >
                        {{ $t("buttons.fileSelect") }}
                      </button>
                      <div>
                        <input
                          v-if="accept"
                          ref="input"
                          type="file"
                          class="d-none"
                          :accept="accept"
                          @change="onChangeFile"
                        >
                        <input
                          v-else
                          ref="input"
                          type="file"
                          class="d-none"
                          @change="onChangeFile"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"

export default {
  name: "ModalFileSelect",
  components: {
    ButtonClose,
  },
  props: {
    accept: { type: String, required: false, default: undefined },
  },
  emits: [
    "close",
    "file-select",
  ],
  data: function () {
    return {
        drag: false,
    }
  },
  computed: {},
  created: function () {
    // イベントリスナ登録
    window.addEventListener("dragover", this.dragAndDropSelectedFile)
  },
  async mounted() {
  },
  // 破棄される前
  beforeUnmount: function () {
    // インスタンスを破棄する前に、イベントリスナから削除
    window.removeEventListener("dragover", this.dragAndDropSelectedFile)
  },

  methods: {
    readfile: async function (event) {
      this.drag = false
      let files = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      this.$emit('file-select', files)
    },
    /**
     * ファイルをドラッグアンドドロップした時の処理
     */
    dragAndDropSelectedFile(e) {
      e.preventDefault()
      if (!this.$el.querySelector(".file-select").contains(e.target)) {
        e.dataTransfer.dropEffect = "none"
        return
      }
      e.stopPropagation()
      e.dataTransfer.dropEffect = "copy"
    },
    // ファイルクリックイベント発火
    onClickFileSelect: function () {
      this.$refs.input.click()
    },
    onChangeFile: function (event) {
      let files = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      this.$emit('file-select', files)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      max-width: 80vw;
      min-width: 560px;
      margin-left: auto;
      margin-right: auto;
      .modal-default-button {
        text-align: right;
      }
      .modal-container {
        overflow: auto;
        max-height: 80vh;
        max-width: 80vw;
        min-width: 560px;
        margin-left: auto;
        margin-right: auto;
        padding: 20px 30px;
        background-color: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
          .modal-contents {
            .file-select {
              border: 2px dotted #ccc;
              border-radius: 6px;
              min-width: 500px;
              min-height: 300px;
              display: flex;
              align-items: center;
              justify-content: center;
              &.dragging {
                border: 2px dotted #999;
                background-color: #eee;
              }
              p {
                text-align: center;
                white-space: pre-wrap;
                line-height: 2rem;
              }
              .button-file-select {
                text-align: center;
                  .btn-sm {
                    padding: 0rem 0.5rem;
                    border-radius: 2rem;
                  }
              }
            }
          }
      }
    }
  }
}
</style>